import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { BoobleModalService } from 'booble-modal';
import { RefusalPaymentDto } from 'src/app/domain/models/dto/refusalPayment.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';

@Component({
  selector: 'app-payment-reproved-inbound',
  templateUrl: './payment-reproved-inbound.component.html',
  styleUrls: ['./payment-reproved-inbound.component.scss'],
})
export class PaymentReprovedInboundComponent implements OnInit {
  boobleModalData: any;
  buttonSend: boolean;

  reasonRefusalPayment: string = 'Pagamento incompleto';
  descriptionRefusalPayment: string = '';

  private readonly notifier: NotifierService;
  public loading: boolean;

  constructor(
    private modalService: BoobleModalService,
    notifierService: NotifierService,
    private readonly ordersService: OrdersService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {}

  changeReasonOption() {
    this.descriptionRefusalPayment = '';
  }

  onDescriptionChange() {
    this.descriptionRefusalPayment =
      this.descriptionRefusalPayment.trim() === ''
        ? ''
        : this.descriptionRefusalPayment;
  }

  validateDescriptionSend() {
    this.buttonSend =
      this.reasonRefusalPayment == 'Outros' &&
      this.descriptionRefusalPayment == ''
        ? true
        : false;

    return this.buttonSend;
  }

  reprovePayment() {
    this.loading = true;
    const reproveData = new RefusalPaymentDto();

    (reproveData.ReasonRefusalPayment = this.reasonRefusalPayment),
      (reproveData.DescriptionRefusalPayment =
        this.descriptionRefusalPayment.trim());

    this.ordersService
      .reprovePayment(this?.boobleModalData.id, reproveData)
      .subscribe({
        next: (orderResult) => {
          this.loading = false;
          this.closeModal();
          this.notifier.notify('success', 'Pagamento recusado com sucesso.');
          this.ordersService.updateOrderView();
        },
        error: (err) => {
          this.loading = false;
        },
      });
  }

  closeModal() {
    this.modalService.dismiss(null);
  }
}
